import React, { useState, useRef, useEffect } from "react";
import userIcon from "../../../../common/assets/images/user-icon.png";
import generalsurgeryIcon from "../../../../common/assets/images/general-surgery-icon.png";
import backIcon from "../../../../common/assets/images/back-icon.png";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const CoderSideDrawer = ({
    handleDragOver,
    handleDrop,
    hanldeSelectQueueEpisodes,
}) => {
    const [openMenu, setOpenMenu] = useState(null); // 'queues' | 'coders' | 'stats' | null
    const menuRef = useRef(null);
    const navigate = useNavigate();
    const codebookusaEnv = process.env.REACT_APP_FLAG_USA;
      const {
    healthInformationManagerData,
  } = useSelector(
    (state) => state.healthInsuranceManager.healthInformationManagerResponse,
  );
    const codebooksanprodEnv = process.env.REACT_APP_FLAG_SAN_PROD;
  const codebooksanEnv = process.env.REACT_APP_FLAG_SAN;
  const isSanEnvironment = codebooksanEnv || codebooksanprodEnv;

    const queues = healthInformationManagerData?.queues || [];
    const coders = healthInformationManagerData?.coders || [];
    const stats = healthInformationManagerData?.stats || {};

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setOpenMenu(null);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className="mobile-qc-menu" ref={menuRef}>
            <div className="mobile-qc-button-container">
                <button
                    className={`mobile-qc-toggle-btn ${openMenu === "queues" ? "active" : ""}`}
                    onClick={() => setOpenMenu(openMenu === "queues" ? null : "queues")}
                >
                    Queues
                </button>
                <button
                    className={`mobile-qc-toggle-btn ${openMenu === "coders" ? "active" : ""}`}
                    onClick={() => setOpenMenu(openMenu === "coders" ? null : "coders")}
                >
                    Coders
                </button>
                <button
                    className={`mobile-qc-toggle-btn ${openMenu === "stats" ? "active" : ""}`}
                    onClick={() => setOpenMenu(openMenu === "stats" ? null : "stats")}
                >
                    My Stats
                </button>
            </div>

            {/* Queues View */}
            {openMenu === "queues" && (
                <div className="mobile-qc-dropdown">
                    {queues.map((item) => (
                        <div
                            key={item.queue_id}
                            className="mobile-qc-item"
                            onDragOver={handleDragOver}
                            onDrop={(e) => handleDrop(e, item, "queues")}
                            onClick={() => hanldeSelectQueueEpisodes("queue", item)}
                        >
                            <img src={generalsurgeryIcon} alt="icon" className="mobile-qc-icon" />
                            <span>
                                {item.queue_name} ({item.number_of_episodes})
                            </span>
                        </div>
                    ))}
                </div>
            )}

            {/* Coders View */}
            {openMenu === "coders" && (
                <div className="mobile-qc-dropdown">
                    {coders.map((item) => (
                        <div
                            key={item.coder_id}
                            className="mobile-qc-item"
                            onDragOver={handleDragOver}
                            onDrop={(e) => handleDrop(e, item, "coders")}
                            onClick={() => hanldeSelectQueueEpisodes("coder", item)}
                        >
                            <img src={userIcon} alt="user" className="mobile-qc-icon" />
                            <span>
                                {item.coder_name} ({item.number_of_episodes})
                            </span>
                        </div>
                    ))}
                </div>
            )}

            {openMenu === "stats" && (
                <div className="mobile-qc-dropdown">
                    <div className="mobile-qc-stats">
                        <div className="stats-value-wrapper">
                            <label>Coded</label>
                            <span>{stats.totalNumberOfEpisodes || 0}</span>
                        </div>
                        {!isSanEnvironment && (
                            <div className="stats-value-wrapper">
                                <label>{codebookusaEnv?"Weight":"NWAU"}</label>
                                <span>{stats.totalEpisodesWeight ? stats.totalEpisodesWeight.toFixed(4) : 0}</span>
                            </div>
                        )}
                        <div className="stats-value-wrapper">
                            <label>$</label>
                            <span>
                                {stats.totalEpisodesWeight
                                    ? Math.round(stats.totalEpisodesWeight * 7258).toLocaleString()
                                    : 0}
                            </span>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CoderSideDrawer;  
